import { computed } from "vue";
import { useTheme } from "vuetify";

/**
 * Dark ⇄ light for the shell chrome AND the hosted module: the global state
 * is the single source of truth (it flips `body[data-theme]`, which some
 * modules key off directly), Vuetify follows it. Shared by SidebarFooter
 * (signed in) and PreAuthPage (before sign-in) — DEV-924 made the tenant's
 * default theme stick until the visitor chooses, and until now the visitor
 * could only choose once inside the app.
 */
export function useThemeToggle() {
  const theme = useTheme();
  const darkMode = computed(() => theme.global.current.value.dark);

  function toggleTheme(): void {
    window.MetaShipGlobalState?.toggleTheme();
    const isDark = window.MetaShipGlobalState?.getState().darkMode ?? !darkMode.value;
    theme.change(isDark ? "dark" : "light");
  }

  return { darkMode, toggleTheme };
}
